function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "caretRight_svg__a"
}, React.createElement("path", {
  d: "M15 12l-6 4V8l6 4z"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 12l-6 4V8l6 4z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#caretRight_svg__a)"
}, React.createElement("path", {
  d: "M4 3h16v18H4z"
}));

function SvgCaretRight(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "caretRight.83a92.svg";
export { SvgCaretRight as ReactComponent };